import { z } from "zod";
import {
  RULE_ID,
  RULE_NAME,
  UPLOAD_FILE
} from "./consts";

export const schema = z.object({
  [RULE_ID]: z.string().optional(),
  [RULE_NAME]: z.string().min(1, "This field is required"),
  [UPLOAD_FILE]: z.any(),
});

export type formValues = z.infer<typeof schema>;
